export const GET_NEWS = "getNews";
export const SET_NEWS = "setNews";
export const GET_LOGIN = "getLogin";
export const SET_LOGIN = "setLogin";
export const GET_COURSESLIST = "getCoursesList";
export const SET_COURSESLIST = "setCoursesList";
export const GET_VALUELIST = "getValueList";
export const SET_VALUELIST = "setValueList";
export const GET_EVENTS = "getEvents";
export const SET_EVENTS = "setEvents";
export const GET_USERGROUPS = "getUserGroups";
export const SET_USERGROUPS = "setUserGroups";
export const GET_SHAREDUSER = "getSharedUser";
export const SET_SHAREDUSER = "setSharedUser";
export const GET_CREATEREFLECTION = "getCreateReflection";
export const SET_CREATEREFLECTION = "setCreateReflection";
export const GET_EDITREFLECTION = "getEditReflection";
export const SET_EDITREFLECTION = "setEditReflection";
export const GET_REMOVEREFLECTION = "getRemoveReflection";
export const SET_REMOVEREFLECTION = "setRemoveReflection";
export const GET_REFLECTION = "getReflection";
export const SET_REFLECTION = "setReflection";
export const GET_CREATECOMMENT = "getCreateComment";
export const SET_CREATECOMMENT = "setCreateComment";
export const GET_COMMENT = "getComment";
export const SET_COMMENT = "setComment";
export const GET_REMOVECOMMENT = "getRemoveComment";
export const SET_REMOVECOMMENT = "setRemoveComment";
export const GET_CREATELIKES = "getCreateLikes";
export const SET_CREATELIKES = "setCreateLikes";
export const GET_LIKES = "getLikes";
export const SET_LIKES = "setLikes";

export const GET_SHAREDUSERS = "getSharedUsers";
export const SET_SHAREDUSERS = "setSharedUsers";

export const GET_UPDATEPROFILE = "getUpdateProfile";
export const SET_UPDATEPROFILE = "setUpdateProfile";

export const GET_TEMPLATE = "getTemplate";
export const SET_TEMPLATE = "setTemplate";

export const GET_CREATE_SHOWCASE = "getCreateShowcase";
export const SET_CREATE_SHOWCASE = "setCreateShowcase";

export const GET_SHOWCASE = "getShowcase";
export const SET_SHOWCASE = "setShowcase";

export const GET_SWITCH_SHOWCASE = "getSwitchshowcase";
export const SET_SWITCH_SHOWCASE = "setSwitchshowcase";

export const GET_UPDATE_SHOWCASE = "getCreateShowcase";
export const SET_UPDATE_SHOWCASE = "setCreateShowcase";

export const GET_REMOVE_SHOWCASE = "getRemoveShowcase";
export const SET_REMOVE_SHOWCASE = "setRemoveShowcase";

export const GET_SEARCH_REFLECTION = "getSearchReflection";
export const SET_SEARCH_REFLECTION = "setSearchReflection";

export const GET_CREATE_SHOWCASE_REFLECTION = "getCreateShowcaseReflection";
export const SET_CREATE_SHOWCASE_REFLECTION = "setCreateShowcaseReflection";

export const GET_SHOWCASE_REFLECTION = "getShowcaseReflection";
export const SET_SHOWCASE_REFLECTION = "setShowcaseReflection";

export const GET_REMOVESHOWCASE_REFLECTION = "getRemoveShowcaseReflection";
export const SET_REMOVESHOWCASE_REFLECTION = "setRemoveShowcaseReflection";

export const GET_CREATE_PUBLIC_ACCESS = "getCreatePublicAccess";
export const SET_CREATE_PUBLIC_ACCESS = "setCreatePublicAccess";

export const GET_SORT_SHOWCASE_REFLECTION = "getSortShowcaseReflection";
export const SET_SORT_SHOWCASE_REFLECTION = "setSortShowcaseReflection";

export const GET_MAP_REFLECTION = "getMapReflection";
export const SET_MAP_REFLECTION = "setMapReflection";

export const GET_TEMPLATE_DETAILS = "getTemplateDetails";
export const SET_TEMPLATE_DETAILS = "setTemplateDetails";

export const GET_REMOVE_TEMPLATE = "getRemoveTemplate";
export const SET_REMOVE_TEMPLATE = "setRemoveTemplate";

export const GET_TASK = "getTask";
export const SET_TASK = "setTask";

export const GET_INBOX_RESPOND = "getInboxRespond";
export const SET_INBOX_RESPOND = "setInboxRespond";

export const GET_DISPLAY_RESPOND = "getDisplayRespond";
export const SET_DISPLAY_RESPOND = "setDisplayRespond";

export const GET_DELETE_RESPOND = "getDeleteRespond";
export const SET_DELETE_RESPOND = "setDeleteRespond";

export const GET_PROFILE_DETAILS = "getProfileDetails";
export const SET_PROFILE_DETAILS = "setProfileDetails";

export const GET_LOGIN_DETAILS = "getLoginDetails";
export const SET_LOGIN_DETAILS = "SetLoginDetails";

export const GET_TOTALUSERSLIST = "getTotalusers";
export const SET_TOTALUSERSLIST = "setTotalusers";

export const GET_USER_REFLECTION = "getUserReflection";
export const SET_USER_REFLECTION = "setUserReflection";

export const GET_TEST_RESPOND = "getTestReflection";
export const SET_TEST_RESPOND = "getTestReflection";

export const GET_TEST_VISUALZATION = "getVisualzation";
export const SET_TEST_VISUALZATION = "setVisualzation";

export const GET_PUBLIC_ACCESS = "getPublicAccess";
export const SET_PUBLIC_ACCESS = "setPublicAccess";

export const GET_ARTEFACTS_IMAGE = "getArtefacts";
export const SET_ARTEFACTS_IMAGE = "setArtefacts";

export const GET_GENERATE_PDF = "getGeneratePdf";
export const SET_GENERATE_PDF = "setGeneratePdf";

export const GET_UPLOAD_FILE = "getUploadimage";
export const SET_UPLOAD_FILE = "setUploadimage";

export const GET_PDF_REFLECTION = "getPdfReflection";
export const SET_PDF_REFLECTION = "setPdfReflection";

export const GET_LOGIN_ACCESS_TOKEN = "getLoginToken";
export const SET_LOGIN_ACCESS_TOKEN = "setLoginToken";

export const GET_REFLECTION_SHARED = "getReflectionShared";
export const SET_REFLECTION_SHARED = "getReflectionShared";

export const GET_DELETE_ATTACHMENTS = "getdeleteAttachements";
export const SET_DELETE_ATTACHMENTS = "setdeleteAttachements";

export const GET_EMPLOYEE_LIST = "getEmployeeList";
export const SET_EMPLOYEE_LIST = "setEmployeeList";

export const GET_EDIT_REFLECTION_USER = "getEditReflectionuser";
export const SET_EDIT_REFLECTION_USER = "setEditReflectionuser";

export const ADD_JOURNAL_PAGE = "ADD_JOURNAL_PAGE";
export const SAVE_JOURNAL_PAGE = "SAVE_JOURNAL_PAGE";

export const GET_JOURNAL_FETCH = "GET_JOURNAL_FETCH";
export const GET_JOURNAL_SUCCESS = "GET_JOURNAL_SUCCESS";
export const TOGGLE_JOURNAL_MORE = "TOGGLE_JOURNAL_MORE";

export const GET_ARTEIMAGES_FETCH = "GET_ARTEIMAGES_FETCH";
export const GET_ARTEIMAGES_SUCCESS = "GET_ARTEIMAGES_SUCCESS";
export const TOGGLE_ARTEIMAGES_MORE = "TOGGLE_ARTEIMAGES_MORE";

export const ADD_ARTEIMAGES_PAGE = "ADD_ARTEIMAGES_PAGE";
export const SAVE_ARTEIMAGES_PAGE = "SAVE_ARTEIMAGES_PAGE";

export const GET_ARTEDOCS_FETCH   = 'GET_ARTEDOCS_FETCH';
export const GET_ARTEDOCS_SUCCESS = 'GET_ARTEDOCS_SUCCESS';
export const TOGGLE_ARTEDOCS_MORE = 'TOGGLE_ARTEDOCS_MORE';

export const ADD_ARTEDOCS_PAGE  = 'ADD_ARTEDOCS_PAGE';
export const SAVE_ARTEDOCS_PAGE = 'SAVE_ARTEDOCS_PAGE';

export const TEACHING_PROCESS_LOADING = 'TEACHING_PROCESS_LOADING';
export const ADD_TEACHING_TASK_LIST = 'ADD_TEACHING_TASK_LIST';
export const ADD_TEACHING_TASK_LIST_FAILED = 'ADD_TEACHING_TASK_LIST_FAILED';
export const GET_TEACHING_TASK_LIST = 'GET_TEACHING_TASK_LIST';
export const UPDATE_TEACHING_TASK_LIST = 'UPDATE_TEACHING_TASK_LIST';
export const DELETE_TEACHING_TASK_LIST = 'DELETE_TEACHING_TASK_LIST';
export const DELETE_TEACHING_TASK_LIST_FAILED = 'DELETE_TEACHING_TASK_LIST_FAILED';
export const GET_TEACHING_TASK_LIST_DETAIL = 'GET_TEACHING_TASK_LIST_DETAIL';
export const GET_TEACHING_DETAILS = 'GET_TEACHING_DETAILS';

export const GET_TASKDATA_POSTS = 'GET_TASKDATA_POSTS';

export const GET_TEACHING_COURSES = "GET_TEACHING_COURSES";

export const GET_LEARNING_TASK_LIST = "GET_LEARNING_TASK_LIST";

export const MY_TASK_PROCESS_LOADING = 'MY_TASK_PROCESS_LOADING';
export const ADD_MY_TASK_LIST = 'ADD_MY_TASK_LIST';
export const ADD_MY_TASK_LIST_FAILED = 'ADD_MY_TASK_LIST_FAILED';
export const GET_MY_TASK_LIST = "GET_MY_TASK_LIST";
export const UPDATE_MY_TASK_LIST = "UPDATE_MY_TASK_LIST";
export const DELETE_MY_TASK_LIST = "DELETE_MY_TASK_LIST";
export const DELETE_MY_TASK_LIST_FAILED = 'DELETE_MY_TASK_LIST_FAILED';
export const GET_MY_TASK_LIST_DETAIL = 'GET_MY_TASK_LIST_DETAIL';

export const GET_TEACHING_PREVIEW = 'GET_TEACHING_PREVIEW';

export const GET_VIDEOS_GALLERY = 'GET_VIDEOS_GALLERY';
export const GET_VIDEOS_LOADING = 'GET_VIDEOS_LOADING';